"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleEligibleCustomerTags = exports.getRuleEligibleCustomerSegments = exports.getRuleEligibleCustomers = exports.previewRuleCoverageProducts = exports.getRuleCoverageProducts = exports.excludeRuleProducts = exports.getRuleCoverage = exports.previewRuleCoverage = exports.estimateRuleItemsCount = exports.resolveRuleProduct = exports.getRuleOverlaps = exports.deleteRule = exports.getRule = exports.updateRule = exports.getRules = exports.createRule = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Create a Prime MOQ rule for a shop
*/
const createRule = (ruleDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: ruleDto
    });
};
exports.createRule = createRule;
/**
* @summary Get a shop's Prime MOQ rules
*/
const getRules = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules`, method: 'get',
        params
    });
};
exports.getRules = getRules;
/**
* @summary Update a Prime MOQ rule for a shop
*/
const updateRule = (id, ruleDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/${id}`, method: 'put',
        headers: { 'Content-Type': 'application/json', },
        data: ruleDto
    });
};
exports.updateRule = updateRule;
/**
* @summary Get a single Prime MOQ rule for a shop
*/
const getRule = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/${id}`, method: 'get'
    });
};
exports.getRule = getRule;
/**
* @summary Delete a Prime MOQ rule for a shop
*/
const deleteRule = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/${id}`, method: 'delete'
    });
};
exports.deleteRule = deleteRule;
/**
* @summary Every (loser, winner) rule pair currently in play, shop-wide
*/
const getRuleOverlaps = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/overlaps`, method: 'get'
    });
};
exports.getRuleOverlaps = getRuleOverlaps;
/**
* @summary Full resolution for one product: which rule wins each limit-type slot, and every rule that matched but lost
*/
const resolveRuleProduct = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/resolve-product`, method: 'get',
        params
    });
};
exports.resolveRuleProduct = resolveRuleProduct;
/**
* @summary Live estimate of how many products/variants a rule's applied-products scope resolves to
*/
const estimateRuleItemsCount = (ruleDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/estimate`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: ruleDto
    });
};
exports.estimateRuleItemsCount = estimateRuleItemsCount;
/**
* @summary Live coverage of an unsaved rule draft: how many of its products it would enforce, and which other rules override the rest
*/
const previewRuleCoverage = (ruleDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/coverage`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: ruleDto
    });
};
exports.previewRuleCoverage = previewRuleCoverage;
/**
* @summary Coverage of a saved rule, recomputed live
*/
const getRuleCoverage = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/${id}/coverage`, method: 'get'
    });
};
exports.getRuleCoverage = getRuleCoverage;
/**
* @summary Bulk exclude/take-over (Pro). Direction-agnostic: the caller's :id and body.conflictedRuleId decide which way.
*/
const excludeRuleProducts = (id, ruleExcludeProductsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/${id}/exclude-products`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: ruleExcludeProductsDto
    });
};
exports.excludeRuleProducts = excludeRuleProducts;
/**
* @summary Full, paginated list of this rule's own variants that lost to byRuleId — the "choose which to exclude" modal (Pro)
*/
const getRuleCoverageProducts = (id, params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/${id}/coverage/products`, method: 'get',
        params
    });
};
exports.getRuleCoverageProducts = getRuleCoverageProducts;
/**
* @summary Same paginated per-variant list as getRuleCoverageProducts, against an unsaved rule draft (no id yet)
*/
const previewRuleCoverageProducts = (rulePreviewCoverageProductsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/coverage/products`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: rulePreviewCoverageProductsDto
    });
};
exports.previewRuleCoverageProducts = previewRuleCoverageProducts;
/**
* @summary List of the shop's customers
*/
const getRuleEligibleCustomers = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/eligibility/customers`, method: 'get'
    });
};
exports.getRuleEligibleCustomers = getRuleEligibleCustomers;
/**
* @summary List of the shop's customer segments
*/
const getRuleEligibleCustomerSegments = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/eligibility/customer-segments`, method: 'get'
    });
};
exports.getRuleEligibleCustomerSegments = getRuleEligibleCustomerSegments;
/**
* @summary List of the shop's customer tags
*/
const getRuleEligibleCustomerTags = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/rules/eligibility/customer-tags`, method: 'get'
    });
};
exports.getRuleEligibleCustomerTags = getRuleEligibleCustomerTags;
